import { createFileRoute } from '@tanstack/react-router';

import { TutorStudentUsageTemplate } from '@/features/tutor-ai';

export const Route = createFileRoute('/_authenticated/tutor-ai/students/$personId/')({
  component: TutorStudentUsagePage,
});

/** Página do relatório de uso e limites de um aluno. */
export function TutorStudentUsagePage() {
  const { personId } = Route.useParams();

  return <TutorStudentUsageTemplate personId={Number(personId)} />;
}
